const TYPEFORM_CUSTOM_INJECTED_JAVASCRIPT = `
    function informReactNative() {
        window?.ReactNativeWebView?.postMessage(JSON.stringify({ showPlaceholder: false }));
    }
    window.onload = (event) => {
        setTimeout(informReactNative, 100);
    };
`;

export default TYPEFORM_CUSTOM_INJECTED_JAVASCRIPT;
